export const GENDER_OPTIONS = [
  { value: 'MALE', label: 'Masculino' },
  { value: 'FEMALE', label: 'Femenino' },
  { value: 'OTHER', label: 'Otro' },
] as const;

export const COMPENSATION_PLAN_OPTIONS = [
  { value: 'A', label: 'Plan A' },
  { value: 'B', label: 'Plan B' },
] as const;

export const SAVINGS_MODE_OPTIONS = [
  { value: 'goal_value', label: 'Objetivo de ahorro' },
  { value: 'savings_capacity', label: 'Capacidad de ahorro' },
  { value: 'withdrawal_goal', label: 'Retiros periódicos' },
] as const;

// Should we make those values uppercase like v1?
export const PAYMENT_PERIODICITY_OPTIONS = [
  { value: 'monthly', label: 'Mensual' },
  { value: 'quarterly', label: 'Trimestral' },
  { value: 'semiannual', label: 'Semestral' },
  { value: 'annual', label: 'Anual' },
] as const;

export const CONTRIBUTION_PERIODICITY_OPTIONS = [
  { value: 'once', label: 'Único' },
  ...PAYMENT_PERIODICITY_OPTIONS,
] as const;

export const REGIME_OPTIONS = [
  { value: 'A', label: 'Régimen A' },
  { value: 'B', label: 'Régimen B' },
] as const;
